import { render } from "./Mo_tableReportList_det.vue?vue&type=template&id=36a7a1b0&scoped=true&ts=true"
import script from "./Mo_tableReportList_det.vue?vue&type=script&lang=ts"
export * from "./Mo_tableReportList_det.vue?vue&type=script&lang=ts"

import "./Mo_tableReportList_det.vue?vue&type=style&index=0&id=36a7a1b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a7a1b0"]])

export default __exports__